import * as Sentry from '@sentry/react'

/**
 * Messages for errors that are part of the normal application flow.
 * They are already handled by the UI, so reporting them to Sentry only
 * adds noise and consumes quota. This list is the single source of truth
 * used both for manual reporting and for the Sentry `beforeSend` filter.
 */
export const expectedErrorMessages = [
  'The user aborted a request.',
  'SessionTimedOut',
  'UnAuthorized',
  'Available subsidiary not found!',
  'Session cannot be authorized, time limit expired!',
  'No subsidiaries found',
  'Non-Error promise rejection captured',
  'Registration failed - push service not available'
]

function getErrorMessage(errorOrMessage) {
  if (!errorOrMessage) {
    return ''
  }

  if (typeof errorOrMessage === 'string') {
    return errorOrMessage
  }

  return errorOrMessage.message || errorOrMessage.toString()
}

export function isExpectedError(errorOrMessage) {
  const message = getErrorMessage(errorOrMessage)

  if (!message) {
    return false
  }

  return expectedErrorMessages.some(expected => message.includes(expected))
}

export function reportException(error) {
  if (isExpectedError(error)) {
    return false
  }

  Sentry.captureException(error)
  return true
}

export function reportMessage(message) {
  if (isExpectedError(message)) {
    return false
  }

  Sentry.captureMessage(message)
  return true
}
